import Vue from 'vue'
import Router from 'vue-router'
// import Hello from '@/components/HelloWorld'
import SignUp from '@/components/auth/SignUp'

import Dashboard from '@/components/Dashboard'
import defaultLayout from '../layouts/DefaultLayout'
//import Login from '../components/Login'
import Login from '../components/auth/Login'
import ForgotPassword from '@/components/auth/ForgotPassword'
import WishlistDetail from '@/components/WishlistDetail'
import PasswordReset from '@/components/auth/PasswordReset'
import HostedWishlist from '@/components/HostedWishlist'
import ArchivedWishlist from '@/components/ArchivedWishlist'
import HostedArchivedWishlist from '@/components/HostedArchivedWishlist'
import ParticipatedArchivedWishlist from '@/components/ParticipatedArchivedWishlist'
import ParticipatedWishlist from '@/components/ParticipatedWishlist'
import rsvp from '@/components/Rsvp'
import ActivateAccount from '@/components/ActivateAccount'
import ChangePassword from '@/components/user/ChangePassword'
import AccountDetails from '@/components/user/AccountDetails'
import PrivacyPolicy from '@/components/auth/PrivacyPolicy'
import TermsAndConditions from '@/components/auth/TermsAndConditions'
import PurchaseEvents from '@/components/payment/PurchaseEvents'
import PaymentHistory from '@/components/payment/PaymentHistory'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'LandingPage',
    component: defaultLayout,
    children: [{
        path: 'signup',
        name: 'SignUp',
        component: SignUp
      },
      {
        path: '',
        name: 'Login',
        component: Login
      },
      {
        path: 'forgotPassword',
        name: 'Forgot Password',
        component: ForgotPassword
      },
      {
        name: 'ResetPassword',
        path: '/resetPassword',
        component: PasswordReset,
      },
      {
        name: 'Activate',
        path: '/activate',
        component: ActivateAccount,
      },
      {
        path: 'hosted',
        name: 'HostedWishlist',
        component: HostedWishlist
      }, {
        path: 'participated',
        name: 'ParticipatedWishlist',
        component: ParticipatedWishlist
      },
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: {
          requiresAuth: true,
          title: 'White Bow Gift Registry - Dashboard',
          metaTags: [{
              name: 'charset',
              content: 'utf-8'
            }, {
              name: 'viewport',
              content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'
            }

          ]
        }
      },
      {
        path: '/wishlist/:id?',
        name: 'WishlistDetail',
        component: WishlistDetail,
        meta: {
          requiresAuth: true,
          title: 'White Bow Gift Registry - Wish list Detail'

        }
      },
      {
        path: '/acceptReject',
        name: 'wishlistRsvp',
        component: rsvp,
        meta: {
          requiresAuth: true,
          title: 'White Bow Gift Registry -Accept Wish list'

        }
      },
      {
        path: '/changePassword',
        name: 'Change Password',
        component: ChangePassword,
        meta: {
          requiresAuth: true,
          title: 'White Bow Gift Registry -Change Password'

        }
      },
      {
        path: '/archived',
        name: 'Archived Events',
        component: ArchivedWishlist,
        meta: {
          requiresAuth: true,
          title: 'White Bow Gift Registry- Archived Events',
          metaTags: [{
              name: 'charset',
              content: 'utf-8'
            }, {
              name: 'viewport',
              content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'
            }

          ]
        }
      },
      {
        path: '/hostedArchive',
        name: 'Hosted Archived Events',
        component: HostedArchivedWishlist,
      },
      {
        path: '/participatedArchive',
        name: 'Participated Archived Events',
        component: ParticipatedArchivedWishlist,
      },
      {

        path: '/accountDetails',
        name: 'Account Details',
        component: AccountDetails,
        meta: {
          requiresAuth: true,
          title: 'White Bow Gift Registry -Account Details'

        }
      },
      {
        path: '/privacyPolicy',
        name: 'Privacy Policy',
        component: PrivacyPolicy
      },
      {
        path: '/termsConditions',
        name: 'Terms And Conditions',
        component: TermsAndConditions
      },
      {
        path: '/purchasePacks',
        name: 'Purchase Packs',
        component: PurchaseEvents
      },
      {
        path: '/paymentHistory',
        name: 'Payment History',
        component: PaymentHistory
      }
    ]
  }],
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({
          x: 0,
          y: 0
        })
      }, 500)
    })
  }

})
router.beforeEach((to, from, next) => {
  if (localStorage.getItem('GiftRegistryAccessToken' + process.env.VUE_APP_ACCESS_TOKEN_NAME) != null && to.path == '/signup') {
    next({
      path: '/dashboard'
    })
  }

  if (localStorage.getItem('GiftRegistryAccessToken' + process.env.VUE_APP_ACCESS_TOKEN_NAME) != null && to.path == '/') {
    next({
      path: '/dashboard'
    })
  }
  if (to.matched.some(record => record.meta.requiresAuth)) //check for requiresAuth value
  {
    if (localStorage.getItem('GiftRegistryAccessToken' + process.env.VUE_APP_ACCESS_TOKEN_NAME) == null) {
      if (to.name == 'WishlistDetail') {
        if (to.query.eventName) {
          localStorage.sharedEvent = JSON.stringify(to.query)
          localStorage.sharedEventId = to.params.id
        }

      }
      router.push({
        path: '/',
        params: {
          nextUrl: to.query
        }
      })
    } else {
      next()
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    if (localStorage.getItem('GiftRegistryAccessToken' + process.env.VUE_APP_ACCESS_TOKEN_NAME) == null) {
      next()
    } else {
      next({
        path: '/signup'
      })
    }
  } else {
    next()
  }
})
export default router;